import { eventCategory } from "@foretagsplatsen/yaem";
import jQuery from "jquery";
import selection from "../../../models/accounting/document/selection.js";

/**
 * I am used to keep manage selections.
 * Since there are multiple kind of selection, and that the key/mouse state
 * need to be kept.
 * I propose a simple interface for my users.
 */

function makeSelectionEventsManager(spec, my) {
	spec ||= {};
	my ||= {};

	const that = {};
	const eventHandler = eventCategory();

	my.controlPressed = false;
	my.shiftPressed = false;
	my.mouseDown = false;
	my.shouldEmptySelection = true;

	let widgets = spec.widgets;

	that.setWidgets = function (newValue) {
		widgets = newValue;
	};

	that.setupEventsForView = function (view) {
		view.asJQuery().mousedown(() => {
			my.mouseDown = true;
			my.shouldEmptySelection = true;
		});
	};

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	that.selectOnMouseMove = function (spec) {
		if (!my.mouseDown) {
			return;
		}
		if (my.shouldEmptySelection && !my.shiftPressed) {
			my.shouldEmptySelection = false;
			eventHandler.trigger("emptySelection");
		}
		selection.addItem(spec);
	};

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	that.toggleEntrySelection = function (spec) {
		const options = {
			entry: spec.entry,
			widget: spec.widget,
			isShiftSelection: false,
		};

		eventHandler.trigger("toggleEntrySelection", options);
	};

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	that.toggleSingleEntrySelection = function (spec) {
		const isSelectionEmpty = selection.isEmpty();
		const widget = spec.widget;
		const entry = spec.entry;

		if (!isSelectionEmpty && my.shiftPressed) {
			shiftSelect(spec.widget);
			return;
		}

		if (my.controlPressed) {
			that.toggleEntrySelection(spec);
			return;
		}

		const options = {
			entry,
			widget,
			isShiftSelection: false,
		};

		eventHandler.trigger("toggleSingleEntrySelection", options);
	};

	that.onSelectOnMouseMove = eventHandler.createEvent("selectOnMouseMove");

	that.onToggleEntrySelection = eventHandler.createEvent(
		"toggleEntrySelection",
	);

	that.onToggleSingleEntrySelection = eventHandler.createEvent(
		"toggleSingleEntrySelection",
	);

	that.onShiftSelect = eventHandler.createEvent("shiftSelect");

	that.onEmptySelection = eventHandler.createEvent("emptySelection");

	function shiftSelect(widget) {
		eventHandler.trigger("shiftSelect", widget, widgets);
	}

	function isOnMac() {
		return navigator.userAgent.indexOf("Mac OS X") !== -1;
	}

	function isOnFirefox() {
		return navigator.userAgent.indexOf("Firefox") !== -1;
	}

	function isOnWebkit() {
		return navigator.userAgent.indexOf("WebKit") !== -1;
	}

	(function installEventHooks() {
		jQuery(document).keydown((event) => {
			// 17 is ctrl keyValue
			let keyCodes = [17];
			if (isOnMac()) {
				// 91 and 93 correspond to left cmd button and right cmd button
				if (isOnFirefox()) {
					keyCodes = [224];
				}
				if (isOnWebkit()) {
					keyCodes = [91, 93];
				}
			}

			// 16 is shift
			if (event.which === 16) {
				my.shiftPressed = true;
				return;
			}

			const match = keyCodes.indexOf(event.which) !== -1;

			if (match) {
				my.controlPressed = true;
			}
		});

		jQuery(document).mousedown((event) => {
			if (
				!jQuery(event.target).closest(".content").length ||
				jQuery(event.target).closest("a , button, input, .entryWidget")
					.length !== 0
			) {
				return;
			}
			eventHandler.trigger("emptySelection");
		});

		jQuery(document).keyup(() => {
			my.controlPressed = false;
			my.shiftPressed = false;
		});

		jQuery(document).mouseup(() => {
			my.mouseDown = false;
		});
	})();

	// Hook to not register manager used during tests
	if (!my.isForTestPurpose) {
		(function registerOnSelection() {
			selection.registerToEventManager(that);
		})();
	}

	return that;
}

const selectionEventsManager = makeSelectionEventsManager();
selectionEventsManager.klass = makeSelectionEventsManager;

export default selectionEventsManager;
